/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {CustomerParentsListPayload,} from '@shared/interface';
import {Observable} from 'rxjs';
import {CustomerStatsInterface} from '@shared/interface/main/overview/overview-stats.interface';

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         9/05/25 - 14:26:07
 * Module name:  stats.service
 * File name:    stats.service.ts
 * IDE:          WebStorm
 */

@Injectable({
  providedIn: 'root',
})
export class StatsService extends MkadBaseService {
  readonly customerEndpoints = URLS_SERVICE.meerkad.customer;

  constructor() {
    super();
  }

  gstStats(params?: CustomerParentsListPayload): Observable<CustomerStatsInterface> {
    return this.http.post<CustomerStatsInterface>(this.customerEndpoints.base + this.customerEndpoints.stats, params);
  }


}
